package com.daytimegaming.ourdailyfinances.domain.usecase

import com.daytimegaming.ourdailyfinances.domain.Response
import com.daytimegaming.ourdailyfinances.domain.model.Budget
import com.daytimegaming.ourdailyfinances.domain.repository.BudgetRepository
import kotlinx.coroutines.flow.Flow

class GetBudgets(private val repo: BudgetRepository) {
    operator fun invoke(): Flow<Response<List<Budget>>> = repo.getBudgets()
}

class CreateBudget(private val repo: BudgetRepository) {
    suspend operator fun invoke(
        name: String,
        categories: List<String>,
        targetValue: Double,
        dashboardIds: List<String>? = null
    ): Response<Budget> = repo.createBudget(name, categories, targetValue, dashboardIds)
}

class UpdateBudget(private val repo: BudgetRepository) {
    suspend operator fun invoke(
        budgetId: String,
        name: String? = null,
        categories: List<String>? = null,
        targetValue: Double? = null,
        dashboardIds: List<String>? = null
    ): Response<Budget> = repo.updateBudget(budgetId, name, categories, targetValue, dashboardIds)
}

class DeleteBudget(private val repo: BudgetRepository) {
    suspend operator fun invoke(budgetId: String): Response<Unit> = repo.deleteBudget(budgetId)
}

class BudgetUseCase(
    val GetBudgets: GetBudgets,
    val CreateBudget: CreateBudget,
    val UpdateBudget: UpdateBudget,
    val DeleteBudget: DeleteBudget
)
